import styled from 'styled-components';
import { colorVars, sizeVars } from '@routific/hive/v5';

// index.html's boot loader reproduces this layout with literal token values, so the mark
// sits in the same spot before and after mount. Changing the padding or background below
// means changing it there too.
export const Container = styled.div<{ $contained?: boolean }>`
  contain: content;
  /* Contained callers (RouteLoadingFallback) supply their own sized box, so the loader
     fills it rather than positioning against the nearest positioned ancestor. */
  position: ${({ $contained }) => ($contained ? 'relative' : 'absolute')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Empty-state token: keeps the mark off the edges when the pane is short. */
  padding: ${sizeVars.empty.padding};
  /* Same fill the nav uses, so the backdrop does not shift when the nav appears. */
  background-color: ${colorVars.surface.canvas.chrome};
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`;
